import {
  aSumoMapping,
  aSumoMappingJsonZipOperation,
  aSumoMappingPage,
  mockSumoMappingsOperationQuery,
  SumoMappingObjectFieldsFragment,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { SumoMappingLogFormat } from 'app/Config/SumoIntegrations/types';

export const mockSumoMapping: Partial<SumoMappingObjectFieldsFragment> = {
  id: '1',
  enabled: true,
  sourceCategory: 'test/mapping',
  vendor: '',
  product: '',
  eventId: '',
  logFormat: SumoMappingLogFormat.Syslog,
  syslogFormat: '',
  syslogDelimiter: '',
  syslogKvDelimiter: '',
  jsonExplode: '',
  jsonZipOperations: [
    aSumoMappingJsonZipOperation({ keyName: '', matchKey: '', matchValue: '' }),
  ],
};

export const handlers = [
  mockSumoMappingsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          sumoMappings: aSumoMappingPage({
            hasNextPage: false,
            objects: [
              aSumoMapping({
                ...mockSumoMapping,
              }),
            ],
            total: 1,
          }),
        },
      });
    }
  ),
];
